import React from 'react'
import CommonConfirmStep from '../common/CommonConfirmStep.js'
import { SubWizardContext } from './SubWizard.js'

export default function ConfirmStep(props) {
  return <CommonConfirmStep {...props} Context={SubWizardContext} />
}
